import Vue from 'vue';
import axios from 'axios';
import {hasPermission} from "../../utils/permissions";

// initial state
const state = {
  organization: {},
  organizations: [],
  organization_search: [],
  total_pages: 0,
//   status: [
//     {name:"Active", value:1},
//     {name:"Trial", value:2},
//     {name:"Inactive", value:3},
//     {name:"Warning", value:4},
// ],
  countries: [],
  states: []
}

// getters
const getters = {
  organization: (state) => {
    return state.organization;
  },
  organizations: (state) => {
    return state.organizations ;
  },
  total_pages: (state) => {
    return state.total_pages;
  },
  organization_search: (state) => {
    return state.organization_search;
  },
  // status: (state) => {
  //   return state.status;
  // },

  states: (state) => {
    return state.states;
  },
  countries: (state) => {
    return state.countries;
  }
}

// mutations
const mutations = {
  SET_ORGANIZATION(state, organization) {
    state.organization = organization;
  },

  SET_ORGANIZATIONS(state, organizations) {
    state.organizations = organizations;
  },

  SET_ORGANIZATION_SEARCH(state, organizations) {
    state.organization_search = organizations;
  },

  SET_TOTAL_PAGES(state, total_pages) {
    state.total_pages = total_pages;
  },

  ADD_CATEGORY(state, organization) {
    state.organizations.push(JSON.parse(JSON.stringify(organization)));
  },

  UPDATE_CATEGORY(state, organization) {
    let organization_index = state.organizations.findIndex((item) => {
      return item.id == organization.id;
    });
    organization.total_posts = state.organizations[organization_index].total_posts;
    Vue.set(state.organizations, organization_index, JSON.parse(JSON.stringify(organization)));
  },

  DELETE_CATEGORY(state, organization) {   
    let index = state.organizations.indexOf(organization);
    if (index > -1) {
      state.organizations.splice(index, 1);
    }
  },


  SET_STATES(state, states){
    state.states = states;
  },
  SET_COUNTRIES(state, states){
    state.countries = states;
  }
}

// actions
const actions = {
  async getAll({commit},[filters]){
    let requestData = {filters: filters, };
    if(hasPermission('all_organization_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_list'
        }
      };
      return axios.get("/common/organization/all", {
        params: requestData,
        ...permission
      })
          .then((response) => {
            // commit('SET_ORGANIZATIONS',response.data.posts);
            return response.data.posts;
          });
    }
  },

  async get_all_organizations ({commit}, page) {
    if(hasPermission('all_organization_list')){
      const permission = {
        headers: {
          'X-Permission': 'all_organization_list'
        }
      };
      await axios.get('/admin/users/get-all-organizations',permission).then((response) => {
        let res = response.data;
        commit('SET_ORGANIZATIONS', res);
      });
    }
  },
  async postVideoLink({commit},[org_id,video_label,video_link]){
            axios.post('/admin/organization/demo-video-link', {org_id, video_label, video_link})
                        .then(() => {
                            // send successful message
                            this.$toast.success("Video link has been uploaded successfully");
                        });
  },
  

  async updateVideoLink({commit},[id,video_label,video_link]){
    axios.post('/admin/organization/update-demo-video-link', {id, video_label, video_link})
                .then(() => {
                    // send successful message
                    this.$toast.success("Video link has been uploaded successfully");
                });
},
async updateTrialDate({commit},[id,trial_date,trial_in_days =false]){
 return await axios.post('/admin/organization/update_trial_date', {id, trial_date,trial_in_days})
              .then(() => {
                
              });
},
async startTrial({},[org_id]){
  return await axios.post('/admin/organization/start-trial', {org_id})
               .then(() => {
                 
               });
 },


  // async getFilterData ({commit}, page) {
  //   if(hasPermission('all_organization_list')){
  //     const permission = {
  //       headers: {
  //         'X-Permission': 'all_organization_list'
  //       }
  //     };
  //     await axios.get(`/admin/users/organization/filter-data/state`,permission).then((response) => {
  //       let res = response.data;
  //       // commit('SET_STATES', res);
  //     });
  //   }
  // },
  // async getCountries ({commit}, page) {
  //   if(hasPermission('all_organization_list')){
  //     const permission = {
  //       headers: {
  //         'X-Permission': 'all_organization_list'
  //       }
  //     };
  //     await axios.get(`admin/users/countries`,permission).then((response) => {
  //       let res = response.data.countries;
  //       // commit('SET_COUNTRIES', res);
  //     });
  //   }
  // },
  // =========================================================================

  // searchCategories({ commit }, [query, current_cat]) {
  //   if(current_cat == undefined)
  //     current_cat = '';
  //   return axios.get('/faqcategories/search?q=' + query + '&current=' + current_cat + '&admin=1')
  //     .then((response) => {
  //       // commit('SET_CATEGORIES_SEARCH', response.data);
  //       commit('SET_CATEGORIES_SEARCH', response.faq);
  //     });
  // },

  // // =========================================================================

  // searchChildCategories({ commit }, query) {
  //   return axios.get('/faqcategories/search-child-FAQcategories?q=' + query)
  //     .then((response) => {
  //       commit('SET_CATEGORIES_SEARCH', response.data.data);
  //       // commit('SET_CATEGORIES_SEARCH', response.data);
  //     });
  // },

  // // =========================================================================

  // getCategory({commit}, slug) {
  //   axios.get('/admin/faqcategories/' + slug)
  //   .then((response) => {
  //     colsole.log(response);
  //     commit('SET_CATEGORY', response.data.category);
  //   });
  // },

  // // =========================================================================

  // createCategory ({commit}, category) {
  //   let moderatorId = null;
  //   let parent_category_id = null;

  //   // if (category.moderator != null) {
  //   //   moderatorId = category.moderator.id;
  //   // }

  //   if (category.parent_category != null) {
  //     parent_category_id = category.parent_category.id;
  //   }

  //   return axios.post('/admin/faqcategories', {
  //     title: category.title,
  //     description: category.description,
  //     // moderator: moderatorId,
  //     parent_id: parent_category_id,
  //   })
  //   .then((response) => {
  //     commit('ADD_CATEGORY', response.data.category);
  //   });
  // },

  // // =========================================================================

  // updateCategory ({commit}, category) {
  //   let moderatorId = null;
  //   let parent_category_id = null;
    
  //   // if (category.moderator != null) {
  //   //   moderatorId = category.moderator.id;
  //   // }
    
  //   if (category.parent_category != null) {
  //     parent_category_id = category.parent_category.id;
  //   }
    
  //   return axios.post('/admin/faqcategories/' + category.slug, {
  //     _method: 'PUT',
  //     title: category.title,
  //     description: category.description,
  //     // moderator: moderatorId,
  //     parent_id: parent_category_id
  //   })
  //   .then((response) => {
  //     commit('UPDATE_CATEGORY', response.data.category);
  //   });
  // },

  // // =========================================================================

  // deleteCategory({commit}, category) {
  //   return axios.post('/admin/faqcategories/' + category.id, {
  //     '_method': 'DELETE'
  //   })
  //   .then((response) => {
  //     commit('DELETE_CATEGORY', category);
  //     return response;
  //   });
  // }

  getOrganizationById({ commit }, [ userId, organizationId ]) {
    if(hasPermission('lead_detail')){
      const permission = {
        headers: {
          'X-Permission': 'lead_detail'
        }
      };
      axios.get(`admin/getOrgUser?user=${userId}&org_id=${organizationId}`,permission)
          .then((response) => {
            commit('SET_ORGANIZATION', response.data);
          })
          .catch((error) => {
            commit('SET_ORGANIZATION', []);
            console.error('Error fetching organization:', error);
          });
    }
  },



};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
